import {useEffect, useState} from "react";
import { Stack, Typography } from "@mui/material";
import BillingService from "../services/BillingService";
import DiagnosticDialog from "../components/DiagnosticDialog";
import CircularProgress from '@mui/material/CircularProgress';
import UserComponent from "../components/User/UserComponent"
import Payment from "./Payment/Paument";
import PromisedPayment from "./PromisedPayment/PromisedPayment";
import Speedtest from "../components/Speedtest";
import ResetPassword from "../components/ResetPassword";

const User = ({ billingId, userId }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(false)

    const [billingUser, setBillingUser] = useState({})
    const [billingUsersGroups, setBillingUsersGroups] = useState([])
    const [billingUserAccounts, setBillingUserAccounts] = useState([])
    const [billingUserServiceLinks, setBillingUserServiceLinks] = useState([])
    const [billingUserIpServices, setBillingUserIpServices] = useState([])
    const [billingUserSwitchesInfo, setBillingUserSwitchesInfo] = useState([])

    const [openDiagnostic, setOpenDiagnostic] = useState(false);
    const [openResetPassword, setOpenResetPassword] = useState(false);
    const [openSpeedtest, setOpenSpeedtest] = useState(false);
    const [openPayment, setOpenPayment] = useState(false);
    const [openPromisedPayment, setOpenPromisedPayment] = useState(false);
    const [paramsDiagnostic, setParamsDiagnostic] = useState({});
    const [paramsSpeedtest, setParamsSpeedtest] = useState({});
    const [paramsPayment, setParamsPayment] = useState({});
    const [paramsPromisedPayment, setParamsPromisedPayment] = useState({});

    const handleOpenDiagnostic = (params) => {
        setParamsDiagnostic(params)
        setOpenDiagnostic(true);
    }

    const handleOpenSpeedtest = (params) => {
        setParamsSpeedtest(params)
        setOpenSpeedtest(true);
    }

    const handleOpenPayment = (params) => {
        setParamsPayment(params)
        setOpenPayment(true);
    }

    const handleOpenPromisedPayment = (params) => {
        setParamsPromisedPayment(params)
        setOpenPromisedPayment(true);
    }

    const handleOpenResetPassword = () => {
        setOpenResetPassword(true);
    }

    const handleClose = () => {
        setOpenDiagnostic(false);
        setOpenSpeedtest(false);
        setOpenResetPassword(false)
    }

    const handleClosePayment = () => {
        setOpenPayment(false);
        fetcher()
    }

    const handleClosePromisedPayment = () => {
        setOpenPromisedPayment(false);
        fetcher()
    }

    const handleUpdate = () => {
        setIsLoading(false)
        fetcher()
    }

    const handleEnableInet = async (account_id) => {
        console.log("handleEnableInet")
        try {
            const responseBillingAccountEnableInet = await BillingService.billing_users_accounts(
                'PUT',
                billingId,
                userId,
                {
                    'user_id': userId,
                    'account_id': account_id,
                    'int_status': 1
                }
            )
            // 
            if (responseBillingAccountEnableInet.status === 200) {
                console.log("PUT billing_users_accounts error")
            }
        } catch (e) {          
            console.log(e);
        }
        fetcher()
    }

    const fetcher = async () => {
        try {
            const responseBillingUser = await BillingService.billing_user(billingId, userId);
            setBillingUser(responseBillingUser.data)
        
            const responseBillingUsersGroups = await BillingService.billing_user_groups(billingId, userId);
            setBillingUsersGroups(responseBillingUsersGroups.data)
        
            const responseBillingUserServiceLinks = await BillingService.billing_user_servicelinks(billingId, userId)
            setBillingUserServiceLinks(responseBillingUserServiceLinks.data)
        
            const responseBillingUserAccounts = await BillingService.billing_users_accounts("GET", billingId, userId);
            setBillingUserAccounts(responseBillingUserAccounts.data.accounts)
        
            const responseBillingUserIpServices = await BillingService.billing_user_ip_services(billingId, userId);
            setBillingUserIpServices(responseBillingUserIpServices.data.ip_services)
            setBillingUserSwitchesInfo(responseBillingUserIpServices.data.switches_information)
        } catch (e) {
            setError(true)
            console.log(e);
        }
        setIsLoading(true)
    };

    useEffect(() => {
        setIsLoading(false)
        setError(false)
        setBillingUser([])
        setBillingUsersGroups([])
        setBillingUserServiceLinks([])
        setBillingUserAccounts([])
        setBillingUserIpServices([])
        setBillingUserSwitchesInfo([])
        fetcher()
    }, [billingId, userId])

    return (
        <Stack
            sx={{
                width: "100%", flexGrow: 1 
            }}
        >
            {/* MODAL Diagnostic */}
            <DiagnosticDialog
                open={openDiagnostic}
                handleClose={handleClose}
                params={paramsDiagnostic}
            >
            </DiagnosticDialog>

            {/* MODAL Speedtest */}
            <Speedtest
                open={openSpeedtest}
                handleClose={handleClose}
                params={paramsSpeedtest}
            >
            </Speedtest>

            {/* MODAL Payment */}
            <Payment
                open={openPayment}
                handleClose={handleClosePayment}
                params={paramsPayment}
            >
            </Payment>
            {/* MODAL Payment */}
            <PromisedPayment
                open={openPromisedPayment}
                handleClose={handleClosePromisedPayment}
                params={paramsPromisedPayment}
            >
            </PromisedPayment>

            {/* MODAL ResetPassword */}
            <ResetPassword
                billingId={billingId}
                user={billingUser}
                open={openResetPassword}
                handleClose={handleClose}
            >
            </ResetPassword>

            {isLoading ?
                !error ?
                    <UserComponent
                        billingId={billingId}
                        handleUpdate={handleUpdate}
                        handleOpenDiagnostic={handleOpenDiagnostic}
                        handleOpenSpeedtest={handleOpenSpeedtest}
                        handleOpenPayment={handleOpenPayment}
                        handleOpenPromisedPayment={handleOpenPromisedPayment}
                        handleEnableInet={handleEnableInet}
                        handleOpenResetPassword={handleOpenResetPassword}
                        billingUser={billingUser}
                        billingUserAccounts={billingUserAccounts}
                        billingUserIpServices={billingUserIpServices}
                        billingUserServiceLinks={billingUserServiceLinks}
                        billingUsersGroups={billingUsersGroups}
                        billingUserSwitchesInfo={billingUserSwitchesInfo}
                    />
                    :
                    <Stack
                        alignItems="center"
                        justifyContent={"center"}
                        sx={{
                            width: "100%",
                            height: "100%",
                            flexGrow: 1,
                        }}
                    >
                        <Typography>An error occurred while loading data from the billing system. Please contact your system administrator.</Typography>
                    </Stack>
                
                : 
                <Stack
                alignItems="center"
                justifyContent={"center"}
                sx={{
                    width: "100%",
                    height: "100%",
                    flexGrow: 1,
                }}>
                    <CircularProgress />
                </Stack>
            }
        </Stack>
    )
}
export default User;